module.exports = __webpack_public_path__ + "img/icon-check.ea86f165.svg";